module.exports = __webpack_public_path__ + "img/GTWM_Main_02.b90a97ee.png";